import { render, staticRenderFns } from "./customer-info-card.vue?vue&type=template&id=0b793d6e"
import script from "./customer-info-card.vue?vue&type=script&lang=js"
export * from "./customer-info-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports